import { render, staticRenderFns } from "./ScrollSpyListItem.vue?vue&type=template&id=3b1d0c22&scoped=true&"
import script from "./ScrollSpyListItem.vue?vue&type=script&lang=js&"
export * from "./ScrollSpyListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d0c22",
  null
  
)

export default component.exports